import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";

import "@fontsource/inter";
import "@fontsource/inter/500.css";

export const RootStyles = createGlobalStyle`
  body {
			font-size: 16px;
			line-height: 24px;
			font-weight: 400;
			letter-spacing: 0.02em;
			font-family: 'Inter', sans-serif;
			padding: 0;
			margin: 0;
  }
	
  a {
    	color: ${theme.colors.brown};
      text-decoration: underline;
  }
	
	button {
			font: inherit;
	}
`;

